{
  "welcome.title": "Barnet ditt har så mye å si",
  "welcome.body": "Svar på noen få korte spørsmål, så lager Timo en gratis, personlig plan som hjelper barnet ditt å finne stemmen sin. Det tar rundt 90 sekunder.",
  "welcome.cta": "Start nå",
  "gender.question": "Er barnet ditt en gutt eller en jente?",
  "gender.opt.boy": "Gutt",
  "gender.opt.girl": "Jente",
  "age.question": "Hvor gammelt er barnet ditt?",
  "age.sub": "Slik at Timo stiller spørsmål som passer alderen.",
  "age.opt.under3": "Under 3",
  "age.opt.3-4": "3-4",
  "age.opt.5-6": "5-6",
  "age.opt.7+": "7+",
  "name.question": "Hva heter barnet ditt?",
  "name.sub": "Eller et kallenavn, så Timo kan gjøre det personlig.",
  "name.placeholder": "Barnets navn",
  "words.question": "Omtrent hvor mange ord kan {name} si?",
  "words.sub": "Et grovt anslag holder fint.",
  "words.opt.0": "0 ord",
  "words.opt.1-5": "1-5 ord",
  "words.opt.6-10": "6-10 ord",
  "words.opt.11-50": "11-50 ord",
  "words.opt.50+": "50+ ord",
  "words.opt.unsure": "Usikker",
  "sentences.question": "Snakker {name} i lengre setninger (4-6 ord) med stort sett riktig grammatikk?",
  "sentences.opt.yes": "Ja",
  "sentences.opt.no": "Nei",
  "delay_fact.title": "Å starte tidlig gir størst forskjell",
  "delay_fact.body": "Noen minutter om dagen med Timo, og {name} gleder seg til det.",
  "delay_fact.cta": "Fortsett",
  "calc.title": "Vi lager kommunikasjonsoversikten for {name}",
  "calc.arr.0": "Vi forstår hva {name} trenger...",
  "calc.arr.1": "Vi sammenligner med milepælene...",
  "calc.arr.2": "Vi velger de riktige aktivitetene...",
  "calc.arr.3": "Nesten klar...",
  "calc.review.text": "Sønnen min gikk fra noen få ord til korte setninger. Med Timo får han selv lyst til å snakke.",
  "calc.review.author": "Rasa, mamma til en 4-åring",
  "score.title": "Kommunikasjonsoversikt for {name}",
  "score.arr.0": "Tale",
  "score.arr.1": "Forståelse",
  "score.arr.2": "Samtale",
  "score.arr.3": "Selvtillit",
  "score.arr.4": "Sosialt",
  "score.cta": "Lag planen for {name}",
  "voice.question": "Velg Timo-stemmen for {name}",
  "voice.sub": "Trykk på et kort for å høre en smakebit.",
  "email.title": "Opprett din gratis konto",
  "email.sub": "Da lagres planen for {name}, og du kan logge inn igjen når som helst.",
  "conversation.question": "Klarer {name} å holde en samtale i gang uten mye hjelp fra voksne?",
  "conversation.opt.yes": "Ja",
  "conversation.opt.no": "Nei",
  "questions.question": "Liker {name} å stille mange spørsmål, som «Hvorfor regner det?»",
  "questions.opt.yes": "Ja",
  "questions.opt.no": "Nei",
  "find_words.question": "Sliter {name} noen ganger med å finne ordene der og da?",
  "find_words.opt.yes": "Ja",
  "find_words.opt.no": "Nei",
  "sounds.question": "Hvilke lyder kan {name} si tydelig?",
  "sounds.sub": "Trykk på alt som passer. Da velger Timo riktige øvelser.",
  "sounds.opt.p_b": "P, B  (pute, bok)",
  "sounds.opt.m_n": "M, N  (matte, nese)",
  "sounds.opt.t_d": "T, D  (topp, dør)",
  "sounds.opt.k_g": "K, G  (katt, gutt)",
  "sounds.opt.f_v": "F, V  (fisk, vann)",
  "sounds.opt.l": "L  (løve)",
  "sounds.opt.r": "R  (rev)",
  "therapist.question": "Har {name} noen gang vært hos logoped?",
  "therapist.opt.yes": "Ja",
  "therapist.opt.no": "Nei",
  "diagnosis.question": "Har {name} fått en diagnose?",
  "diagnosis.sub": "Dette forblir privat og hjelper bare Timo med å tilpasse.",
  "diagnosis.opt.autism": "Autisme / ASF",
  "diagnosis.opt.speech_delay": "Forsinket språkutvikling",
  "diagnosis.opt.adhd": "ADHD",
  "diagnosis.opt.none": "Ingen diagnose",
  "diagnosis.opt.prefer_not": "Vil helst ikke si",
  "social.question": "Synes {name} at grupper eller sosiale situasjoner er vanskelige?",
  "social.opt.yes": "Ja",
  "social.opt.no": "Nei",
  "goals.question": "Hvordan kan Timo hjelpe {name} mest?",
  "goals.sub": "Velg opptil 3. Det former hele planen.",
  "goals.opt.confidence": "Snakke med mer selvtillit",
  "goals.opt.conversations": "Øve på hverdagssamtaler",
  "goals.opt.social": "Takle vanskelige sosiale situasjoner",
  "goals.opt.feelings": "Uttrykke følelser på en sunn måte",
  "goals.opt.calm": "Holde seg rolig når alt blir for mye",
  "goals.opt.school": "Bli klar for skolen",
  "topics.question": "Velg favorittemaene til {name}",
  "topics.sub": "Timo vever dem inn i øvelsene.",
  "topics.opt.animals": "Dyr",
  "topics.opt.space": "Verdensrommet",
  "topics.opt.vehicles": "Kjøretøy",
  "topics.opt.music": "Musikk",
  "topics.opt.nature": "Natur",
  "topics.opt.food": "Mat",
  "experts.title": "Laget med fagfolk, tilpasset {name}",
  "experts.body": "Timo Helps bygger på et rammeverk for språk og kommunikasjon ved autisme, og formes så etter svarene dine om {name}. Aldri én løsning for alle.",
  "experts.quote.text": "Over 10 000 familier bruker Timo Helps for å hjelpe barnet sitt å finne stemmen sin.",
  "experts.quote.author": "4,8 i snitt",
  "experts.cta": "Se planen for {name}",
  "learn_style.question": "Hvordan liker {name} best å lære?",
  "learn_style.opt.hands_on": "Praktiske aktiviteter",
  "learn_style.opt.stories": "Å lytte til historier",
  "learn_style.opt.video": "Å se videoer",
  "learn_style.opt.games": "Å spille spill",
  "strengths.question": "Hva er styrkene til {name}?",
  "strengths.sub": "Velg alt som passer.",
  "strengths.opt.creative": "Kreativitet",
  "strengths.opt.curious": "Nysgjerrighet",
  "strengths.opt.caring": "Omsorg",
  "strengths.opt.determined": "Målbevissthet",
  "strengths.opt.funny": "Humor",
  "challenge.question": "Hva er den største utfordringen for {name} nå?",
  "challenge.opt.frustrated": "Blir lett frustrert",
  "challenge.opt.distracted": "Blir lett distrahert",
  "challenge.opt.shy": "Sjenert eller engstelig med folk",
  "challenge.opt.overwhelmed": "Blir fort overveldet",
  "daily_time.question": "Hvor mye øving er realistisk hver dag?",
  "daily_time.sub": "Selv noen få minutter summerer seg fort.",
  "daily_time.opt.5": "Et lite løft",
  "daily_time.hint.5": "5 min per dag",
  "daily_time.opt.10": "Helt passe",
  "daily_time.hint.10": "10 min per dag",
  "daily_time.opt.20": "For fullt",
  "daily_time.hint.20": "20 min per dag",
  "when.question": "Når skal {name} øve?",
  "when.opt.morning": "Morgen",
  "when.hint.morning": "En rolig start",
  "when.opt.afternoon": "Ettermiddag",
  "when.hint.afternoon": "Et løft midt på dagen",
  "when.opt.evening": "Kveld",
  "when.hint.evening": "Roe ned før leggetid",
  "who_uses.question": "Hvem skal bruke Timo Helps sammen med {name}?",
  "who_uses.opt.mom": "Mamma",
  "who_uses.opt.dad": "Pappa",
  "who_uses.opt.grandparent": "Besteforelder",
  "who_uses.opt.specialist": "Terapeut eller lærer",
  "who_uses.opt.themselves": "På egen hånd",
  "timeline.question": "Hvor raskt vil du se framgang?",
  "timeline.opt.weeks": "Om noen uker",
  "timeline.opt.1-2m": "Om 1-2 måneder",
  "timeline.opt.no_rush": "Ingen fast tidsramme",
  "main_goal.question": "Hva er hovedmålet ditt nå?",
  "main_goal.opt.catch_up": "Hjelpe {name} å ta igjen",
  "main_goal.opt.on_track": "Holde framgangen i gang",
  "main_goal.opt.confidence": "Bygge selvtilliten til {name}",
  "main_goal.opt.other": "Noe annet",
  "profile_done.title": "Hele planen for {name} er klar",
  "profile_done.body": "Timo har alt han trenger. La oss øve sammen.",
  "profile_done.cta": "Kom i gang"
}
